/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { MockRule } from "./MockRule";
import { SpecialRequestHeader } from "./SpecialRequestHeader";
import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum Http_methodEnum {
  "GET" = "GET",

  "POST" = "POST",

  "PUT" = "PUT",

  "DELETE" = "DELETE",

  "PATCH" = "PATCH",

  "OPTIONS" = "OPTIONS",

  "TRACE" = "TRACE"
}

/**
 * The mock resource, analyzed by Mocker, that permits to generate different responses based by rules and conditions.
 */

// required attributes
const MockResourceR = t.interface({
  tags: t.readonlyArray(t.string, "array of string"),

  http_method: enumType<Http_methodEnum>(Http_methodEnum, "http_method"),

  is_active: t.boolean,

  name: t.string,

  rules: t.readonlyArray(MockRule, "array of MockRule"),

  special_headers: t.readonlyArray(
    SpecialRequestHeader,
    "array of SpecialRequestHeader"
  ),

  subsystem: t.string
});

// optional attributes
const MockResourceO = t.partial({
  id: t.string,

  resource_url: t.string
});

export const MockResource = t.intersection(
  [MockResourceR, MockResourceO],
  "MockResource"
);

export type MockResource = t.TypeOf<typeof MockResource>;
